import { render, staticRenderFns } from "./CompanyEditTabAccount.vue?vue&type=template&id=dba9f46a&"
import script from "./CompanyEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./CompanyEditTabAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports